<template>
    <div class="richTable-body t-promos scrollbar is-docked">
        <div class="richTable-row t-promos-row js-collapse-head">
            <div class="richTable-col" style="--width:25%; --width-md:10%;">
                <img :src="promotion.logo.urls.small" class="img-fluid" />
            </div>
            <div
                class="richTable-col t-promos-name d-block"
                style="--width:50%; --width-md:70%; --width-lg:47%;"
            >
                <span class="typo--label">{{ promoType }}</span>
                <h3 class="h6 richTable-title mb-0 mr-2">
                    {{ promotion.name }}
                </h3>
            </div>
            <div
                class="richTable-col align-self-center text-right"
                style="--width:25%; --width-md:15%;"
            ></div>
            <div
                class="richTable-col t-promos-actions mt-3 mt-lg-0"
                style="--width:100%; --width-md:100%; --width-lg:28%;"
            >
                <the-btn
                    v-if="!showShops"
                    :text="'Dostosuj ceny'"
                    @click.native="showShops = !showShops"
                    :btnClass="'btn-outline-custom flex-grow-1'"
                    :icon="'Edit'"
                ></the-btn>
                <the-btn
                    v-if="showShops"
                    :text="'Zwiń'"
                    @click.native="showShops = !showShops"
                    :btnClass="'btn-outline-custom flex-grow-1'"
                    :icon="'Edit'"
                ></the-btn>
                <the-btn
                    @click.native="deselectPromo(promotion.id)"
                    :btnClass="'btn-outline btn-icon is-danger'"
                    :icon="'Close'"
                ></the-btn>
            </div>

            <!-- <transition name="slide"> -->
            <div
                v-if="showShops"
                class="t-shops-wrapper collapse richTable-col js-collapse"
                :class="{ show: showShops }"
                style="--width-md:100%;"
            >
                <div class="t-shops-settings">
                    <span>
                        Wybrano
                        <strong
                            >{{ selectedShops.length }} z
                            {{ promotionShops.length }}</strong
                        >
                        sklepów dla tej promocji
                    </span>
                </div>
                <div class="t-shops scrollbar">
                    <div class="scrollbar-shadow is-top"></div>
                    <div class="sth">
                        <template
                            v-if="
                                promotion.products &&
                                    promotion.products.length > 0
                            "
                        >
                            <change-price-product
                                :data="product"
                                v-for="(product, idx) in promotion.products"
                                :key="idx"
                                :prodId="idx"
                                :promotion="promotion"
                            />
                        </template>
                        <template
                            v-if="
                                promotion.product_sets &&
                                    promotion.product_sets.length > 0
                            "
                        >
                            <change-price-product-sets
                                :productSet="productSet"
                                v-for="(productSet,
                                idxx) in promotion.product_sets"
                                :key="idxx"
                                :setIdx="idxx"
                                :promotion="promotion"
                                :groupId="promotion.groupId"
                            />
                        </template>
                    </div>
                    <div class="scrollbar-shadow is-bottom"></div>
                </div>
            </div>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script>
import ChangePriceProduct from '@/components/promotions/ChangePriceProduct'
import ChangePriceProductSets from '@/components/promotions/ChangePriceProductSets'

export default {
    data() {
        return {
            showShops: false
        }
    },
    props: {
        promotion: {
            type: Object,
            required: true
        },
        merchants: {
            type: Array,
            required: true
        }
    },
    components: {
        ChangePriceProduct,
        ChangePriceProductSets
    },
    methods: {
        deselectPromo(promoId) {
            this.$store.dispatch('selectPromotion', {
                id: promoId,
                value: false
            })
            this.$store.dispatch('setSelectAllPromotions', false)
        }
    },
    computed: {
        promotionShops() {
            return this.$store.getters.getPromotionShops({
                promoId: this.promotion.id,
                groupId: this.promotion.groupId
            })
        },
        selectedShops() {
            return this.$store.getters.getSelectedShops(this.promotion.id)
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.promotion.type)
        }
    }
}
</script>
